import { CurrencyIcon } from '@repo/ui/currency-icon';
import { Skeleton } from '@repo/ui/skeleton';
import { useTranslations } from 'next-intl';
import React, { type ReactNode } from 'react';
import { PAYMENT_TYPES } from '@/constants';
import { type FullMethod } from '@/hooks/usePaymentMethodsWithNetworks';

type DepositCryptoDetailsHeaderProps = {
  selectedMethod?: FullMethod;
  backButtonRenderer?: ReactNode;
};

const DepositCryptoDetailsHeader = ({ selectedMethod, backButtonRenderer }: DepositCryptoDetailsHeaderProps) => {
  const t = useTranslations(PAYMENT_TYPES.DEPOSITS);
  return (
    <div className="flex w-full items-center justify-between border-b border-[var(--surface-lighter-bg)] py-2.5">
      <div className="flex items-center justify-center font-bold vt-text-size-bigger sm:vt-text-size-bigger-sm">
        {backButtonRenderer}
        <div className="flex w-full items-center justify-start space-x-2 rtl:space-x-reverse">
          {selectedMethod?.currencyCode ? (
            <CurrencyIcon
              className="size-5"
              currency={selectedMethod?.currencyCode?.toLowerCase()}
            />
          ) : (
            <Skeleton className="size-5 rounded-full p-3.5" />
          )}
          {selectedMethod?.currencyCode ? (
            <span>{t('payment-type')}</span>
          ) : (
            <Skeleton className="h-5 w-20 rounded p-3.5" />
          )}
        </div>
      </div>
      <div className="w-1/2 text-right vt-text-size-small vt-headings-text sm:vt-text-size-small-sm">
        <span>{t('crypto-details-description-1', { crypto: selectedMethod?.currencyCode || '' })}</span>
      </div>
    </div>
  );
};

export default DepositCryptoDetailsHeader;
